import * as constants from './constants';

export function statCampaignDetail(campaign, status, dateFrom, dateTo) {
  return {
    type: constants.STAT_CAMPAIGN_DETAIL_REQUEST,
    isFetching: true,
    campaign,
    status,
    dateFrom,
    dateTo,
  };
}

export function statCampaignDetailError(error) {
  return {
    type: constants.STAT_CAMPAIGN_DETAIL_FAILURE,
    isFetching: false,
    errorMessage: error,
  };
}

export function statCampaignDetailSuccess(data) {
  data.reverse();
  return {
    type: constants.STAT_CAMPAIGN_DETAIL_SUCCESS,
    isFetching: false,
    errorMessage: null,
    data,
  };
}



// WEBPACK FOOTER //
// ./src/containers/Statistics/actions.js